import { NavLink } from 'react-router-dom';
import { useAuth } from '../../features/auth/AuthContext';
import { useProjectNavItems } from './projectNavItems';

export default function SideNav({
    projectId,
    collapsed = true,
    onNavigate,
}: {
    projectId?: string;
    collapsed?: boolean;
    onNavigate?: () => void;
}) {
    const { me } = useAuth();
    const projectItems = useProjectNavItems(projectId);

    const clsItem = (isActive: boolean, disabled?: boolean) => {
        if (disabled) {
            return 'flex items-center gap-3 px-3 py-2 text-sm rounded bg-gray-100 text-gray-400 cursor-not-allowed';
        }
        return `flex items-center gap-3 px-3 py-2 text-sm rounded ${
            isActive ? 'bg-gray-900 text-white' : 'text-gray-700 hover:bg-gray-50'
        }`;
    };

    const Item = ({
        to,
        label,
        end = false,
        disabled = false,
    }: {
        to: string;
        label: string;
        end?: boolean;
        disabled?: boolean;
    }) => (
        <NavLink
            to={disabled ? '#' : to}
            end={end}
            onClick={(e) => {
                if (disabled) {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }
                onNavigate?.();
            }}
            aria-disabled={disabled}
        >
            {({ isActive }) => (
                <div className={clsItem(isActive, disabled)}>
                    <span className="truncate">{label}</span>
                </div>
            )}
        </NavLink>
    );

    return (
        <div className="p-2">
            {me?.isServiceAdmin && (
                <>
                    <div className="px-4 py-3 text-xs font-semibold text-gray-500">SERVICE ADMIN</div>
                    <Item to="/service" label="Overview" end />
                    <Item to="/admin/companies" label="Companies" />
                    <Item to="/admin/users" label="Users" />
                    <Item to="/admin/roles" label="Roles" />
                    <Item to="/admin/permissions" label="Permissions" />
                </>
            )}

            {(me?.isCompanyAdmin || me?.isServiceAdmin) && (
                <>
                    <div className="px-4 py-3 text-xs font-semibold text-gray-500">COMPANY ADMIN</div>
                    <Item to="/company" label="Organization" end />
                    <Item to="/company/profile" label="Profile" />
                    <Item to="/company/partners" label="Partners" />
                    <Item to="/company/users" label="Users" />
                    <Item to="/company/projects" label="Projects" />
                </>
            )}

            <div>
                <div
                    className={`mb-2 px-2 text-[11px] text-gray-500 ${
                        collapsed ? 'opacity-0 pointer-events-none' : ''
                    }`}
                >
                    Navigation
                </div>

                {!projectId ? (
                    <nav className="space-y-1">
                        <Item to="/projects" label="My Projects" end />
                    </nav>
                ) : (
                    <>
                        <nav className="space-y-1">
                            {projectItems.map((item) => (
                                <Item
                                    key={item.key}
                                    to={item.to}
                                    label={item.label}
                                    end={item.end}
                                    disabled={item.disabled}
                                />
                            ))}
                        </nav>

                        {/* <div
                            className={`mt-4 px-2 text-[11px] text-gray-500 ${
                                collapsed ? 'opacity-0 pointer-events-none' : ''
                            }`}
                        >
                            Quick
                        </div>
                        <div className="space-y-1">
                            <Item to={`/projects/${projectId}/wbs?filter=DELAY`} label="지연 WBS" />
                            <Item to={`/projects/${projectId}/tasks?filter=OVERDUE`} label="연체 Task" />
                        </div> */}
                    </>
                )}
            </div>
        </div>
    );
}
